module.exports = {
	colors: {
		main: '#ed1c24',
		sec: '#ffcb08',
		alt: '#ed1c24',
	},

	showFunds: false,
	showBuses: false,
	showHomeworks: true,
	showSchoolDay: true,
	useCourses: false,
	useUploadChatImage: false,

	about: {
		mobiles: ['0943717120'],
		phones: [],
		address: '',
		data: [0, 0],
		email: null,
		facebook: 'https://www.facebook.com/alrowadschooool?mibextid=ZbWKwL',
		privacy: null,
		details: [
			{
				title: 'كلمة الرواد',
				content: [
					'في مؤسسة الرواد نقدم لكم نظاماً تعليمياً متكاملاً يفتح آفاق جديدة لنمو أبنائكم وتطورهم.',
					'نحرص على تقديم بيئة تعليمية ملهمة تجمع بين المعرفة و الابتكار.',
					'دعونا نساعدكم في تشكيل جيل مبدع وقادر على مواجهة تحديات الغد.',
					'انضموا إلينا و لنبنِ مستقبل أبنائكم معاً.',
				],
			},
		],
	},

	pwa: {
		name: 'مؤسسة الرواد التعليمية',
		shortName: 'مؤسسة الرواد التعليمية',
		description: 'تطبيق الرواد - نسخة محمولة من تطبيق الرواد',
	},
};
